import { devtoolsAddLog, devtoolsClearLogs } from '../store/devTools/actions';

class GlazeConsole {
  constructor(dispatch) {
    this.dispatch = dispatch;

    this.copy = console.log;

    this.isActive = false;

    this.update = this.update.bind(this);
    this.ownLogs = this.ownLogs.bind(this);
  }

  ownLogs(...data) {
    this.copy(...data);

    this.dispatch(devtoolsAddLog(data));
  }

  update(state) {
    let isActive = false;

    if (state.devTools.preserveLogs) {
      console.log = this.ownLogs;

      isActive = true;
    } else {
      console.log = this.copy;
    }

    if (isActive !== this.isActive && !isActive) {
      this.dispatch(devtoolsClearLogs());
    }

    this.isActive = isActive;
  }
}

export default GlazeConsole;
